import { minEstCost } from '../minEstCost/minEstCost';
import { RndMinEstCostFunction } from './rndMinEstCost.types';

/**
 * Returns the minimum price of a recommended-or-needed-declined (RND) service, or null if non-existent.
 */
export const rndMinEstCost: RndMinEstCostFunction = (rnd) => {
    if (rnd.price !== null && rnd.price !== undefined) {
        return rnd.price;
    }
    else if (rnd.linkedService) {
        if (rnd.linkedService.useSpgPricing) {
            return minEstCost(rnd.linkedService);
        }
        else {
            return rnd.linkedService.price ?? null;
        }
    }

    return null;
};
